import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BehaviorSubject, Observable, of } from 'rxjs';

import {
  Category,
  FinnairBoundItem,
  FinnairCart,
  FinnairItineraryItemFlight,
  FinnairOrder,
  FinnairPassengerItem,
  FinnairServiceItem,
} from '@fcom/dapi/api/models';
import { GtmPurchaseFlow } from '@fcom/common/interfaces/gtm.interface';

import { EligibilitiesForFragments, FlightWithStreams, SeatChangeEvent } from '../../../interfaces';
import { AncillaryLoaderStatus } from '../../../enums';

@Component({
  selector: 'fin-ancillary-seat-map',
  templateUrl: './ancillary-seat-map.component.html',
  standalone: false,
})
export class AncillarySeatMapComponent {
  @Input() flight: FlightWithStreams;
  @Input() cartOrOrder$: Observable<FinnairCart | FinnairOrder>;
  @Input() passengers$: Observable<FinnairPassengerItem[]>;
  @Input() flightIsActive$: Observable<boolean>;
  @Input() includedSeats: FinnairServiceItem | null;
  @Input() availability$: Observable<EligibilitiesForFragments> = of({});
  @Input() canClearSeats = true;
  @Input() preSelectedPax$: Observable<string> = of(undefined);
  @Input() ancillaryLoader$: BehaviorSubject<AncillaryLoaderStatus>;
  @Input() notEligibleWhenCheckInClosed = false;
  @Input() skipScroll = false;
  @Input() purchaseFlow: GtmPurchaseFlow;
  @Input() bounds$: Observable<FinnairBoundItem[]>;
  @Input({ required: true }) contextCategory: Category;

  @Output() changeSeats: EventEmitter<SeatChangeEvent> = new EventEmitter();
  @Output() retrySeatmap: EventEmitter<FinnairItineraryItemFlight> = new EventEmitter();
  @Output() finishedReassigningSeats: EventEmitter<boolean> = new EventEmitter();

  seatSelected(e: SeatChangeEvent): void {
    this.changeSeats.emit(e);
  }

  emitFinishedReassigningSeats(): void {
    this.finishedReassigningSeats.emit();
  }
}
